var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-mobile-nav-basic', [_c('u-mobile-nav-head-basic', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-hamburger-primary', {
    staticClass: "btn-hamburger--mobile active"
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("모바일 메뉴 닫기")])])], 1)], 1)], 1), _c('u-mobile-nav-body-basic', [_c('gnb', {
    attrs: {
      "gnbName": "gnb-mo"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }